import { useContext, useState } from 'react'
import { UserContext } from '../../context/UserContext'
import { useMutation, useQueryClient } from 'react-query'
import { CastService } from '../../services/CastService'
import { useEffect } from 'react'
import { NotificationContext } from '../../context/NotificationContext'
import LoadingAnimation from './LoadingAnimation'

export default function NewCastItem({ selectedCastTypeId }) {
  const { user } = useContext(UserContext)
  const { setNotificationInfo } = useContext(NotificationContext)

  const queryClient = useQueryClient()

  const [newCastName, setNewCastName] = useState('')

  /* ****************** Mutation Hook ****************** */
  const createCast = useMutation(({ user, payload }) => CastService.createUserCast(user.accessToken, payload), {
    onSuccess: () => {
      queryClient.invalidateQueries('casts')
    },
  })

  /* ****************** JSX / Variables ****************** */
  const liClassName = 'p-4'
  const inputClassName = `w-full px-5 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs border-gray-300 rounded-md ${
    createCast.isLoading ? 'ring-green-500' : ''
  } ${createCast.isError ? 'ring-red-500' : ''}`

  /* ****************** Functions ****************** */
  const handleChange = (ev) => {
    setNewCastName(ev.currentTarget.value)
  }

  const handleKeyPress = (ev) => {
    if (ev.key === 'Enter') {
      const payload = {
        name: newCastName,
        castValues: [],
        isActive: false,
        companyId: user.companyId,
        castTypeId: selectedCastTypeId,
        userHashEmail: user.hashEmail,
      }

      createCast.mutate({ user, payload })
    }
  }

  /* ****************** Use Effects ****************** */
  useEffect(() => {
    if (createCast.isSuccess) {
      setNotificationInfo({ type: 'success', message: 'Created Cast', show: true })
      createCast.reset()
      setNewCastName('')
    }

    if (createCast.isError) {
      setNotificationInfo({ type: 'error', message: createCast.error.message, show: true })
      createCast.reset()
    }
  }, [createCast, createCast.isError, createCast.isSuccess, setNotificationInfo])

  /* ****************** Render ****************** */
  return (
    <li key="new-cast-entry" className={liClassName}>
      {createCast.isLoading ? <LoadingAnimation /> : null}
      {createCast.isLoading ? null : (
        <input
          className={inputClassName}
          type="text"
          onChange={handleChange}
          value={newCastName}
          placeholder={newCastName === '' ? 'Add New Cast' : undefined}
          onKeyPress={handleKeyPress}
        />
      )}
    </li>
  )
}
